import { render, staticRenderFns } from "./ExternalBrokerSearchAndRegistration.vue?vue&type=template&id=00a86680"
import script from "./ExternalBrokerSearchAndRegistration.vue?vue&type=script&lang=js"
export * from "./ExternalBrokerSearchAndRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports